module.exports = __webpack_public_path__ + "img/expenses-types-x.906acbc3.svg";